<template>
  <main id="content" aria-labelledby="main-title" v-if="page">

    <ElementHeroInfo :content="{
      title: page.title,
      subtitle: page.subtitle,
      pretitle: null
    }" />

    <BlockLogos :content="{ title: 'Building trust and transparency with' }" />

    <Section v-if="page?.story">
      <Container>
        <FadeIn class="mt-8 lg:mt16 md:grid md:grid-cols-12 lg:grid-cols-12">
          <div 
          class="max-w-2xl md:col-span-8 lg:col-span-7 mb-8">
            <h2 class="text-section-title" v-if="page.story">Our story</h2>
          </div>
          <div
          v-if="page.story" 
          v-html="page.story"
          v-interpolation
          class="prose md:col-span-8 lg:col-span-8 relative"
          ></div>
        </FadeIn>
      </Container>
    </Section>

    <BlockTeam />

    <template v-if="page?.dynamic">
      <template v-for="(section, index) in page?.dynamic">
        <component 
        :is="getSectionComponent(section.collection)" 
        :sectionIndex="index" 
        :content="section.item" 
        />
      </template>
    </template>
    
    <ElementBookDemoCta />

  </main>
</template>

<script setup>
const route = useRoute()
const contentSections = useContentSections()
const { getItems } = useCms()
const fields = useFields()

const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

const { data } = await useAsyncData(
  currentLocale.value+'-page-about',
  () => getItems({
    collection: 'about',
    params: {
      fields
    },
  })
)

const page = data?.value

const seo = computed(() => {
  if (page?.seo) {
    return useSeo(page.seo, route.fullPath)
  }
  return {}
})

useHead(seo)

const getSectionComponent = key => {
  return contentSections[key]
}

</script>